<template>
  <portal v-if="render" selector="#custom-attributes-management">
    <div class="v-application" style="display: block">
      <ConfirmationDialogProvider>
        <Header2>Eigene Felder bearbeiten</Header2>
        <CustomAttributesManagement />
      </ConfirmationDialogProvider>
    </div>
  </portal>
</template>

<script lang="ts">
import { defineComponent, onMounted, Ref, ref } from "vue"
import Header2 from "app/ui-primitives/header/Header2.vue"
import CustomAttributesManagement from "app/modules/custom-attributes/CustomAttributesManagement.vue"
import ConfirmationDialogProvider from "features/common/confirmation-dialog/ConfirmationDialogProvider.vue"
import { CustomAttributesClient } from "app/modules/custom-attributes/client"

export default defineComponent({
  name: "CustomAttributesManagementPortal",
  components: {
    ConfirmationDialogProvider,
    CustomAttributesManagement,
    Header2,
  },
  setup() {
    const render = ref(false)
    const clientId: Ref<number | null> = ref(null)
    const levelId: Ref<number | null> = ref(null)

    onMounted(() => {
      const mountingPoint = document.querySelector(
        "#custom-attributes-management"
      )
      if (mountingPoint) {
        //mountingPoint.classList.add("v-application") // add vuetify styles
        // read the data attribute and parse it as json
        const dataRaw = mountingPoint.getAttribute("data")
        const data = dataRaw ? JSON.parse(dataRaw) : {}
        clientId.value = data.clientId ?? null
        levelId.value = data.levelId ?? null
        render.value = true
        CustomAttributesClient.loadContext(clientId.value, levelId.value)
      }
    })

    return {
      render,
    }
  },
})
</script>
